import { inject } from '@angular/core';
import { HttpErrorResponse, HttpResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, filter, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { CustomHeader } from '../models/header.enum';
import { AppService } from '../services/app.service';
import { HttpCustomeErrorResponse } from '../models/http-custome-error-response';

export const errorCatchingInterceptor: HttpInterceptorFn = (req, next) => {
  const translate = inject(TranslateService);
  const appService = inject(AppService);
  let skipNotification = false;
  if (req.headers.has(CustomHeader.SkipNotificationHeader)) {
    req = req.clone({ headers: req.headers.delete(CustomHeader.SkipNotificationHeader) });
    skipNotification = true;
  }

  return next(req)
    .pipe(
      filter(event => event instanceof HttpResponse),
      tap(() => {
        if (!skipNotification) {
          switch (req.method) {
            case 'POST': appService.showMsg(translate.instant(`http.successfullyCreated`)); break;
            case 'PUT': appService.showMsg(translate.instant(`http.successfullyUpdated`)); break;
            case 'PATCH': appService.showMsg(translate.instant(`http.successfullyUpdated`)); break;
            case 'DELETE': appService.showMsg(translate.instant(`http.successfullyDeleted`)); break;
          }
        }
      }),

      catchError((error: HttpErrorResponse) => {
        if (skipNotification) {
          return throwError(() => error);
        }
        console.error(error);
        // HttpClient wraps the server's problem-details body in `error.error`;
        // `error.code`/`error.status` on the HttpErrorResponse itself are not
        // the backend error code, so the server-provided `code` was never read.
        const problem = error.error as HttpCustomeErrorResponse | null;
        appService.showMsg(translate.instant(`http.error`, {
          errorTitle: translate.instant(`http.${problem?.code || error.status}`),
        }), 'error');
        return throwError(() => error);
      }),

    );
}
